import "../../../../src/content/wg-christmas-2023/wg-joytotheworld-2023.scss";
import * as React from 'react';
export default {
  React
};